import generateUID from "@/utils/uid";

export default {
  namespaced: true,
  state: {
    errors: [],
  },
  mutations: {
    ADD_ERROR(state, { uid, message }) {
      const newError = {};
      newError[uid] = message;
      state.errors = { ...state.errors, ...newError };
    },
    REMOVE_ERROR(state, { uid }) {
      const errors = state.errors;
      delete errors[uid];
      state.errors = errors;
    },
  },
  actions: {
    async SHOW_ERROR({ commit }, { message, duration = 1000 }) {
      const uid = generateUID();
      commit("ADD_ERROR", { uid, message });
      setTimeout(() => {
        commit("REMOVE_ERROR", { uid });
      }, duration);
    },
  },
};
